import { render, staticRenderFns } from "./SelectedSources.vue?vue&type=template&id=58d69d28&scoped=true&"
import script from "./SelectedSources.vue?vue&type=script&lang=js&"
export * from "./SelectedSources.vue?vue&type=script&lang=js&"
import style0 from "./SelectedSources.vue?vue&type=style&index=0&id=58d69d28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d69d28",
  null
  
)

export default component.exports